import './App.css';
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

// Public pages
import NotFound from './pages/NotFound';
import Login from './pages/Login';

// Protected pages
import Book from './pages/Book';
import Timeline from './pages/TimeLine';
import AddBook from './pages/AddBook';
import Statistics from './pages/Statistics';
import Reader from './pages/Reader';
import StatDetails from './pages/StatDetails';
import Browse from './pages/Browse';
import Library from './pages/Library';
import Dashboard from './pages/Dashboard';

// Admin pages
import Admin from './pages/Admin/Admin';
import EditBook from './pages/Admin/EditBook';

// components
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Serie from './pages/Admin/Serie';
import Bookshelves from './pages/Bookshelves';
import Wheel from './pages/Wheel';
import Profile from './pages/Profile';


const UserLayout = () => (
  <ProtectedRoute>
    <Outlet />
  </ProtectedRoute>
);


const AdminLayout = () => (
  <ProtectedRoute>
    <AdminRoute>
      <Outlet />
    </AdminRoute>
  </ProtectedRoute>
);

function App() {


  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* user routes */}
          {/* <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}></Route>
          <Route path="/Library" element={<ProtectedRoute><Library /></ProtectedRoute>}></Route>
          <Route path="/Browse" element={<ProtectedRoute><Browse /></ProtectedRoute>}></Route>
          <Route path="/Book/:bookId" element={<ProtectedRoute><Book /></ProtectedRoute>}></Route>
          <Route path="/Reader/:bookId" element={<ProtectedRoute><Reader /></ProtectedRoute>}></Route>
          <Route path="/add-book" element={<ProtectedRoute><AddBook /></ProtectedRoute>}></Route>
          <Route path="/Timeline/:year" element={<ProtectedRoute><Timeline /></ProtectedRoute>}></Route>
          <Route path="/stats" element={<ProtectedRoute><Statistics /></ProtectedRoute>}></Route>
          <Route path="/stats/details" element={<ProtectedRoute><StatDetails /></ProtectedRoute>}></Route> */}

          <Route element={<UserLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/Library" element={<Library />} />
            <Route path="/Browse" element={<Browse />} />
            <Route path="/Book/:bookId" element={<Book />} />
            <Route path="/Reader/:bookId" element={<Reader />} />
            <Route path="/add-book" element={<AddBook />} />
            <Route path="/Timeline/:year" element={<Timeline />} />
            <Route path="/stats" element={<Statistics />} />
            <Route path="/stats/details" element={<StatDetails />} />
            <Route path="/bookshelf" element={<Bookshelves />} />
            <Route path="/wheel" element={<Wheel />} />
            <Route path="/profile" element={<Profile />} />
          </Route>

          {/* admin routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Admin />} />
            <Route path="editBook" element={<EditBook />} />
            <Route path="addSerie" element={<Serie />} />
          </Route>

          {/* public routes */}
          <Route path="/Login" element={<Login />}></Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
